module.exports = __webpack_public_path__ + "img/newlogo.de60080b.png";